import { useListViewContext } from 'features/views/ListView/useListViewContext'

export function useSortAvailableFields(): FieldDto[] {
    const { visibleFields } = useListViewContext()

    return visibleFields
}
